import React, { useContext } from "react";
import ReactDOM from "react-dom";
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import { LangCtx } from "../../../lib/context";

const DeletePrescModal = (props) => {
    const { l } = useContext(LangCtx);

    return ReactDOM.createPortal(
        <div className={props.openDelete ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="btmDtlPaper">
                <div className="btmDtlHeader">
                    <span className="hdrTxt">{l.delete} {l.presc}</span>
                </div>
                <div className="btmDtlBdy">
                    <span className="summaryTxt">{l.del_presc}</span>
                </div>
                <div className="hdrAction">
                    <div className="hdrActionBox">
                        <span className="hrActionTxt" onClick={(e) => props.closeDelete(e)}>{l.cancel}</span>
                    </div>
                    <div className="hdrActionBox">
                        <span className="hrActionTxt" onClick={props.handleDelete}>{l.delete}</span>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default DeletePrescModal;
